import { UploadedFile } from 'types';

import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { SuccessData } from 'types/api';

export const outsourceInvoiceMutations = getMutations({
  uploadOutsourceInvoicePayment: {
    action: async (payload: {
      id: string;
      file: UploadedFile;
      date: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: 'invoice/outsource-invoices/payment',

        method: 'post',

        payload,
      });
    },
  },

  registerOutsourceInvoice: {
    action: async (payload: {
      id: string;
      companyName: string;
      taxId: string;
      address: string;
      paymentTerms: string;
      currency: string;
      value: string;
      comments: string;
      emails: string[];
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: 'invoice/outsource-invoices/register',

        method: 'post',

        payload,
      });
    },
  },

  uploadClientOutsourceInvoiceFile: {
    action: async (payload: {
      id: string;
      file: UploadedFile;
      sentToPayment: boolean;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: 'invoice/outsource-invoices/upload-invoice',

        method: 'post',

        payload,
      });
    },
  },
});
